interface WorkoutItemLike {
  type: string;
  parentId: string | null;
}

// A cardio workout's planned content lives on its root CARDIO item. Workouts
// without planned cardio (strength, imported activities) have none.
export function findMainCardioItem<T extends WorkoutItemLike>(
  workoutItems: readonly T[],
): Extract<T, { type: "CARDIO" }> | null {
  return (
    workoutItems.find(
      (workoutItem): workoutItem is Extract<T, { type: "CARDIO" }> => {
        return workoutItem.type === "CARDIO" && workoutItem.parentId === null;
      },
    ) ?? null
  );
}
